import { render } from "./ListePrepaidAccount.vue?vue&type=template&id=3435c83a&ts=true"
import script from "./ListePrepaidAccount.vue?vue&type=script&lang=ts"
export * from "./ListePrepaidAccount.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__